/**
 * Permission codes the intercompany screens declare an interest in
 * (`internal/interco/permissions.go`, design C3 §6.1).
 *
 * `interco.transaction.match` ⊗ `interco.statement.certify` is a declared
 * segregation-of-duties pair: whoever decides that two entries are the same
 * transaction should not also be the one who attests that the pair reconciled.
 */

export const INTERCO_PERMISSIONS = {
  pairRead: 'interco.pair.read',
  pairManage: 'interco.pair.manage',

  /** Match, unmatch, dispute or write off one intercompany transaction. */
  transactionMatch: 'interco.transaction.match',
  /** Step-up MFA. Certifying is what clears the close blocker (§9.6). */
  statementCertify: 'interco.statement.certify',

  /** Read companies for the pair pickers and for naming a counterparty. */
  companyRead: 'org.company.read',
  /** Read fiscal periods: a statement is per period. */
  periodRead: 'org.period.read',
} as const

export type IntercoPermission = (typeof INTERCO_PERMISSIONS)[keyof typeof INTERCO_PERMISSIONS]
